module.exports = __webpack_public_path__ + "img/dimsum-1.e9153bcd.jpg";